import Navbar from "../components/navbar/Navbar";
import OrderSuccess from "../components/orders/OrderSuccess";
import Footer from "../components/footer/Footer";
import Banner from "../components/banner/Banner";
const OrderSucc=()=>{
    return(
      <section className="ftco-menu  pb-5">
                <div className="bg-imagea">
                <Navbar/>
        <div>
            <Banner title="Order summary"/>
<OrderSuccess/>
<Footer/>
    </div>
    </div>
    </section>
    )
}
export default OrderSucc;
